module.exports = __webpack_public_path__ + "static/language-selector-screen1-e770fdae2611dcd14ad235a70e16fbda.png";